import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const FailureIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.22854 18.6448C1.56074 19.7127 2.45113 20.9942 3.67542 20.9942H20.3702C21.5945 21.101 22.3736 19.7127 21.8171 18.6448L13.4697 3.80093C12.8019 2.73302 11.2437 2.73302 10.5759 3.80093L2.22854 18.6448ZM12.0228 5.3083L4.3266 18.9942H19.719L12.0228 5.3083ZM12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18ZM11 14C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14V9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9V14Z"
      />
    </Icon>
  );
};
